import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { loadSession, monitorAPI, saveSession } from '@/services/api'

export const useAuthStore = defineStore('auth', () => {
  const session = ref(loadSession())
  const authenticated = computed(() => Boolean(session.value?.token))

  async function login(username: string, password: string): Promise<void> {
    session.value = await monitorAPI.login(username, password)
    saveSession(session.value)
  }

  async function verify(): Promise<boolean> {
    if (!session.value?.token) return false
    try {
      await monitorAPI.session()
      return true
    } catch {
      session.value = null
      saveSession(null)
      return false
    }
  }

  async function logout(): Promise<void> {
    try {
      await monitorAPI.logout()
    } finally {
      session.value = null
      saveSession(null)
    }
  }

  async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await monitorAPI.changePassword(currentPassword, newPassword)
    session.value = null
    saveSession(null)
  }

  return { session, authenticated, login, verify, logout, changePassword }
})
